<script setup lang="ts">
import { cn } from "@/lib/utils";

// 1) Expect 'id' from the parent.
const props = defineProps<{ id: string }>();

defineExpose({
  commands: [],
  properties: {
    id: "card-footer",
    name: "Card Footer",
    icon: "lucide:panel-bottom",
  },
});
</script>

<template>
  <!-- A container for the card footer. -->
  <CardFooter :class="cn($attrs.class ?? '')">
    <slot />
  </CardFooter>
</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.CARD_FOOTER,
  icon: "lucide:panel-bottom",
  type: "Card Footer",
  description: "Container block that renders the card footer area.",
  default: {},
  categories: ["Layout"],
  hiddenUntilFiltered: true,
  order: 12020,
};
</script>
